const zh = {
  i18nView: {
    account: '账号',
    balance: '余额',
    fund: '储备金',
    login: '登录',
    logout: '登出',
    previousPage: '上一页',
    index: '首页',
    nextPage: '下一页',
    personalInfo: '个人信息',
    rexFundTips: '买卖REX、借入资源需要提前将',
    rexFundTips1: '从余额中转入到REX储备金，使用REX储备金中的',
    rexFundTips2: '去买卖REX、资源借入等操作',
    iknow: '我知道了',
    amount: '数量',
    overview: '总览信息',
    totalRex: 'REX 总量',
    totalEos: '总量',
    lendable: '可用租赁',
    lent: '已租赁',
    rentCost: '资源租赁收入',
    lentPercent: '租赁比率',
    deposit: '充值REX储备金',
    withdraw: '提现REX储备金',
    rexPriceTrend: 'REX价格趋势',
    rexTrading: 'REX买卖',
    buyRex: '买 REX',
    sellRex: '卖 REX',
    availableRex: '当前可卖',
    unstakeToRex: '取消抵押转为REX',
    stakedAccount: '已抵押账号',
    unstake: '取消抵押',
    day: '天',
    resourceFund: '资源储备金',
    myRexHistory: '我的REX交易记录',
    resPrice: '每个EOS可借入资源趋势(30天)',
    resBorrow: '借入CPU/NET',
    currentPrice: '当前价格',
    resType: '资源类型',
    resReceiver: '资源接收者',
    payment: '支付',
    borrow: '一键借入',
    orders: '正在借入的订单',
    dueTime: '到期时间',
    stakeList: '已抵押列表',
    unstakeTips: '可以取消已抵押的资源并转化为REX,无需等待三天到账',
    viewRestRex: '查看锁定详情',
    maturityTime: '解锁时间',
    noStakeRecord: '没有抵押记录',
    rexMaturity: 'Rex解锁列表',
    voteTips: '购买REX需要提前投票给至少21个节点或者一个代理节点,你可以在本页面直接购买,如果你未满足要求,我们会默认将票投给我们的代理节点',
    success: '执行成功',
    you: '你',
    unstakeToRexTips: '请根据该账号的资源使用情况进行解押, 解押过多可能会失败',
    postiveAmount: '请至少输入一个大于0的资源进行解押',
    resourceFundTips: '*资源储备金可以在30天后为你续费你的借入订单。它是可选项，并且在订单期间你可以随时向资源储备金中存储或提取',
    fundText: '存储资源储备金',
    unfundText: '提取资源储备金',
    depositRes: '存储',
    withdrawRes: '提取',
    willGet: '获得 ',
    waitingForDeploy: 'eosio合约出错',
    switchto: '切换到',
    rexValue: 'REX 对应价值',
    resTips: '*借入资源会消耗你的代币，请不要在不了解该功能的情况下使用',
    ramIncome: '内存手续费收入',
    bidnameIncome: '短账号收入',
    apr: '预估年化收益率',
    manageRexSavings: '管理REX储蓄桶',
    rexSavings: 'REX储蓄桶',
    savingTips: '对于希望长期持有REX的用户，可以将REX抵押锁定在储蓄桶内，需要卖出REX时，需要提前取消抵押然后等待大概5天后解锁，才可以进行卖出。',
    staked: '已抵押(储蓄桶)',
    stakeable: '可抵押',
    stakeRex: '抵押REX',
    unstakeRex: '取消抵押REX',
    rentPrice: '资源租借价格',
    totalRentNumber: '资源租借次数',
    myRexInQueue: '我在排队卖出中的REX',
    currentRexQueue: 'REX卖出排队订单数',
    cancelRexQueue: '取消出售',
    updateRexStatus: '更新状态',
    queueing: '有效',
    myQueueIndex: '排队序号',
    loanStatus: '即将到期的借出订单',
    availableEosPercent: '可用百分比',
    viewExpiredOrder: '查看即将到期的订单',
    helpCleanOrder: '❤ 帮忙清理过期订单',
    refresh: '刷新数据',
    sellRexOrder: '卖出REX排队中的订单',
    borrowInvilidTip: '*到期的订单会优先支付卖出REX队列中的订单，订单处理完毕后，可租用数量占已租用数量超过20%，才可以正常借入资源',
    applyTime: '提交时间',
    expiredTime: '过期时间'
  }
};

export default zh;



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js